import { render, staticRenderFns } from "./SideItem.vue?vue&type=template&id=c0c3a88a&scoped=true"
import script from "./SideItem.vue?vue&type=script&lang=js"
export * from "./SideItem.vue?vue&type=script&lang=js"
import style0 from "./SideItem.vue?vue&type=style&index=0&id=c0c3a88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c3a88a",
  null
  
)

export default component.exports